(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.actionbar = {
    attach: function (context, settings) {
      const actionBar = $('.js-action-bar', context);
      const sideBar = $('.js-action-sidebar', context);
      actionBar.click(function () {
        if (actionBar.hasClass('is-active')) {
          $(this).removeClass('is-active');
          sideBar.removeClass('is-active');
          $('html', context).removeClass('is-scrolling');
          if ($('body', context).hasClass('path-results')) {
            $(this).text('Search again?');
          } else {
            $(this).text('Show Summary & Help');
          }
          return;
        }
        $(this).addClass('is-active');
        sideBar.addClass('is-active');
        $('html', context).addClass('is-scrolling');
        if ($('body', context).hasClass('path-results')) {
          $(this).text('Hide Search');
        } else {
          $(this).text('Hide Summary & Help');
        }
      });
    }
  };
})(window.Drupal, window.jQuery);
